import router from "@/router";
import moment from "moment";
import vm from "@/main";
function addHandle() {
  //0:异常日志(默认)    1:操作日志
  var obj = {
    logType: 1,
    appName: "", //应用名称
    operType: "", //操作类型
    orignalData: "", //
    currentData: "", //
    changeData: "", //
    api: "", //完整api地址
    apiParam: "", //参数
    apidata: "", //接口响应数据
    remark: "", //
    time: "", //创建时间
    systemType: "", //系统类型
    systemName: "", //系统名称
    brandId: "", //
    brandName: "", //
    regionAgentId: "", //
    regionAgentName: "", //
    storeId: "", //
    storeName: "", //
    accountId: "", //登录用户ID
    accountName: "", //登录用户名
    createTime: "", //创建时间
    modelId: "", //模块ID
    modelName: "", //模块名称
    menuId: "",
    menuName: "",
    operationId: "",
    operationName: "",
    env: "", //dev:开发环境  pre:预发布环境  prd:生产环境
    deviceCode: "",
  };
}

function getDiff(a, b) {
  const result = {};
  const keys = Object.keys(a);
  for (const key of keys) {
    if (a[key] !== b[key]) {
      if (JSON.stringify(b[key]) != JSON.stringify(a[key])) {
        if (
          ((JSON.stringify(b[key]) != "" && JSON.stringify(a[key]) !== "[]") ||
            (JSON.stringify(a[key]) != "" &&
              JSON.stringify(b[key]) !== "[]")) &&
          !(b[key] == undefined && a[key] + "" === "") &&
          !(a[key] == undefined && b[key] + "" === "")
        ) {
          console.log(a[key] + ":" + b[key]);
          console.log("hha" + a[key]);
          result[key] = a[key];
        }
      } else {
        console.log("h222ha---" + a[key]);
      }
    }
  }
  return result;
}
export function handleChangeObj(ori, current) {
  console.log("差别");
  var obj = getDiff(ori, current);
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      obj[key] = "默认值"; // 例如，你可以赋值为一个空字符串、0或其他任何默认值
    }
  });
  return obj;
}
export function sendWebSocket111(apiUrl, params, permission) {
  // const a = { ad: 1, df: 2 };
  // const b = { ad: 3, df: 2 };
  // console.log(getDiff(a, b)); // 输出: { ad: 1, df: 2 }
  // return;
  // console.log("接受那些二");
  // console.log(apiUrl);
  // console.log(params);
  // console.log(permission);
  // //BrandManagement/add
  // //根据权限查找对应的模块
  //
  // let permissionList = JSON.parse(
  //   localStorage.getItem("permission_list_maomao")
  // );
  // console.log("权限书");
  // var maomaoList = [];
  // permissionList.forEach((item) => {
  //   if (item.systemId == 3) {
  //     maomaoList.push(item);
  //   }
  // });
  // var obj = {
  //   logType: 1,
  //   appName: "", //应用名称
  //   operType: 1, //操作类型
  //   operTypeName: "新增",
  //   orignalData: "", //
  //   currentData: "", //
  //   changeData: "", //
  //   api: "", //完整api地址
  //   apiParam: "", //参数
  //   apidata: "", //接口响应数据
  //   remark: "", //
  //   time: moment(new Date()).format("YYYY-MM-DD  HH:mm:ss"), //创建时间
  //   systemType: 3, //系统类型
  //   systemName: "品牌商系统", //系统名称
  //   brandId: "", //
  //   brandName: "", //
  //   regionAgentId: "", //
  //   regionAgentName: "", //
  //   storeId: "", //
  //   storeName: "", //
  //   accountId: "", //登录用户ID
  //   accountName: "", //登录用户名
  //   createTime: moment(new Date()).format("YYYY-MM-DD  HH:mm:ss"), //创建时间
  //   modelId: "", //模块ID
  //   modelName: "", //模块名称
  //   menuId: "",
  //   menuName: "",
  //   operationId: "",
  //   operationName: "",
  //   env: "", //dev:开发环境  pre:预发布环境  prd:生产环境
  //   deviceCode: "",
  // };
  // console.log(maomaoList);
  //
  // maomaoList.forEach((item) => {
  //   var message = "";
  //   var param = {};
  //   var applicationId = item.applicationId; //模块id
  //   var permissionId = item.permissionId;
  //   var applicationName = item.applicationName; //模块名称
  //   if (item.applicationName == "品牌管理") {
  //     item.resourceMenuList.forEach((item1) => {
  //       console.log(item1);
  //       if (item1.menuCode === permission) {
  //         var menuId = item1.menuId; //模块id
  //         var menuName = item1.menuName;
  //         var parentId = item1.parentId;
  //         var nextId = "";
  //         var nextN = "";
  //         if (permission === "BrandManagement/add") {
  //           nextId = item1.buttons[0].buttonId;
  //           nextN = item1.buttons[0].buttonName;
  //         }
  //         item.resourceMenuList.forEach((item1) => {
  //           if (item1.menuId === parentId) {
  //             var parentName = item1.menuName;
  //
  //             message = 1;
  //             param = {
  //               appName: applicationName, //应用名称
  //               modelId: applicationId, //模块ID
  //               modelName: applicationName, //模块名称
  //               menuId: parentId,
  //               menuName: parentName,
  //               operationId: menuId,
  //               operationName: menuName,
  //             };
  //             if (nextId !== "") {
  //               param.operationId = menuId + "_" + nextId;
  //               param.operationName = menuId + "_" + nextN;
  //             }
  //             if (message !== "") {
  //               return;
  //             }
  //           }
  //         });
  //         if (message !== "") {
  //           return;
  //         }
  //       }
  //     });
  //   }
  //
  //   if (message != "") {
  //     console.log({ ...obj, ...param });
  //     console.log(param);
  //   }
  // });
  //
  //   for (let key in permissionList) {
  //     if (permissionList.hasOwnProperty(key)) {
  //       // 确保是对象自身的属性
  //
  //       var keyName = key;
  //       var valueList = permissionList[key];
  //       valueList.forEach((item) => {
  //         if (item.menuCode === permission) {
  //           //找到按钮的权限了
  //         }
  //         if (item.buttons && item.buttons.length > 0) {
  //           item.buttons.forEach((item1) => {
  //             if (item1.menuCode === permission) {
  //               //找到按钮的权限了
  //             }
  //           });
  //         }
  //       });
  //     }
  //   }
  // }
}
export function handleWebParamsData(perUrl, appId, type, password) {
  //权限  应用id
  let permissionList = JSON.parse(
    localStorage.getItem("permission_list_maomao")
  );

  var maomaoList = [];
  permissionList.forEach((item) => {
    if (item.systemId == 1) {
      maomaoList.push(item);
    }
  });

  var list = [];
  maomaoList.forEach((item) => {
    item.resourceMenuList.forEach((item1) => {
      if (item1.parentId === 0) {
        //只是父级  需要删掉 放到相应的位置
        vm.$set(item1, "children", []);
        vm.$set(item1, "applicationId", item.applicationId);
        vm.$set(item1, "applicationName", item.applicationName);
        item.resourceMenuList.forEach((item2) => {
          if (item2.parentId === item1.menuId) {
            item1.children.push(item2);
            vm.$set(item2, "children", []);
            item.resourceMenuList.forEach((item3) => {
              if (item2.menuId === item3.parentId) {
                item2.children.push(item3);
              }
            });
          }
        });

        list.push(item1);
      } else {
      }
    });
  });

  var obj = {
    logType: 1,
    appName: "总后台系统", //应用名称
    operType: type, //操作类型
    type: type,
    operTypeName:
      type === 1
        ? "新增"
        : type === 2
        ? "编辑"
        : type === 3
        ? "删除"
        : type === 4
        ? "导入"
        : type === 2
        ? "导出"
        : "暂无",
    orignalData: "", //
    currentData: "", //
    changeData: "", //
    api: "", //完整api地址
    apiParam: "", //参数
    apidata: "", //接口响应数据
    remark: "", //
    time: moment(new Date()).format("YYYY-MM-DD  HH:mm:ss"), //创建时间
    systemType: 1, //系统类型
    systemName: "总后台系统", //系统名称
    brandId: "", //
    brandName: "", //
    regionAgentId: "", //
    regionAgentName: "", //
    storeId: "", //
    storeName: "", //
    accountId: "", //登录用户ID
    accountName: "", //登录用户名
    createTime: moment(new Date()).format("YYYY-MM-DD  HH:mm:ss"), //创建时间
    modelId: "", //模块ID
    modelName: "", //模块名称
    menuId: "",
    menuName: "",
    operationId: "",
    operationName: "",
    env: "", //dev:开发环境  pre:预发布环境  prd:生产环境
    deviceCode: "",
  };
  if (password != null) {
    obj.password = password;
  }

  var returnObj = undefined;
  list.forEach((item) => {
    var message = "";
    var param = {};
    var applicationId = item.applicationId; //模块id
    var applicationName = item.applicationName; //模块名称

    if (item.applicationId == appId) {
      console.log("进入也能" + perUrl);
      var menuId = item.menuId; //模块id
      var menuName = item.menuName;
      console.log("进入也能" + JSON.stringify(item));
      item.buttons.forEach((item1) => {
        if (item1.buttonCode === perUrl) {
          console.log(perUrl + "=============" + JSON.stringify(item1));
          console.log(item);
          console.log(item1);
          var nextId = "";
          var nextN = "";
          nextId = item1.buttonId;
          nextN = item1.buttonName;
          message = 1;
          param = {
            appName: applicationName, //应用名称
            modelId: applicationId, //模块ID
            modelName: applicationName, //模块名称
            menuId: menuId,
            menuName: menuName,
            operationId: nextId,
            operationName: nextN,
          };
          console.log(param);
        }
      });

      if (item.children && item.children.length > 0) {
        item.children.forEach((item1) => {
          item1.buttons.forEach((item2) => {
            if (item2.buttonCode === perUrl) {
              console.log(item);
              console.log(item1);
              console.log(item2);
              var nextId = "";
              var nextN = "";

              nextId = item2.buttonId;
              nextN = item2.buttonName;
              message = 1;
              param = {
                appName: applicationName, //应用名称
                modelId: applicationId, //模块ID
                modelName: applicationName, //模块名称
                menuId: menuId,
                menuName: menuName,
                operationId: item1.menuId + "_" + nextId,
                operationName: item1.menuName + "_" + nextN,
              };
              console.log(param);
            }
          });
          if (item1.children && item1.children.length > 0) {
            item1.children.forEach((item2) => {
              item2.buttons.forEach((item3) => {
                if (item3.buttonCode === perUrl) {
                  console.log(item);
                  console.log(item1);
                  console.log(item2);
                  console.log(item3);
                  var nextId = "";
                  var nextN = "";

                  nextId = item3.buttonId;
                  nextN = item3.buttonName;
                  message = 1;
                  param = {
                    appName: applicationName, //应用名称
                    modelId: applicationId, //模块ID
                    modelName: applicationName, //模块名称
                    menuId: menuId + "_" + item1.menuId,
                    menuName: menuName + "_" + item1.menuName,
                    operationId: item2.menuId + "_" + nextId,
                    operationName: item2.menuName + "_" + nextN,
                  };
                  console.log(param);
                }
              });
            });
          }
        });
      }
    }

    if (message != "") {
      returnObj = { ...obj, ...param };
      console.log(returnObj);
    }
  });

  return returnObj != undefined ? returnObj : undefined;
}

export function handleUrlLink(urlLink, params, postData) {
  var returnParams = undefined;
  console.log("连接" + urlLink);
  console.log(router.history.current.path);
  var pathHist = router.history.current.path;
  if (urlLink.indexOf("/customer/add") != -1) {
    //haha
    returnParams = handleWebParamsData("clientlist/add", 1, 1);
  } else if (urlLink.indexOf("customer/update") != -1) {
    //haha
    console.log();
    returnParams = handleWebParamsData("/clientlist/update", 1, 2);
  } else if (urlLink.indexOf("customer/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("clientlist/delete", 1, 3);
  } else if (urlLink.indexOf("/customer/permission/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/customer/permission/update", 1, 1);
  } else if (urlLink.indexOf("customer/user/init") != -1) {
    //haha
    returnParams = handleWebParamsData("/customer/user/init", 1, 2, "password");
  }
  // else if (urlLink.indexOf("customer/bind/phone") != -1) {
  //   console.log("修改登录手机号");
  //   //haha
  //   returnParams = handleWebParamsData("/customer/bind/phone", 1, 2);
  //   console.log("修改登录手机号222");
  //   console.log(returnParams);
  // }
  else if (urlLink.indexOf("/customer/bind/phone") != -1) {
    //haha

    returnParams = handleWebParamsData(
      "/customer/bind/phone/update",
      1,
      2,
      "updatePhone"
    );
  } else if (urlLink.indexOf("/market/application/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/market/application/add", 2, 1);
  } else if (urlLink.indexOf("/market/application/update") != -1) {
    //haha
    if (postData.sj) {
      returnParams = handleWebParamsData("/market/application/update1", 2, 2);
    } else if (postData.xj) {
      returnParams = handleWebParamsData("/market/application/update", 2, 2);
    } else {
      returnParams = handleWebParamsData("/application/update", 2, 2);
    }
  } else if (urlLink.indexOf("/menu/add") != -1) {
    //haha
    console.log("最后的商户号");
    console.log(postData);
    if (postData.parentId + "" != "0") {
      returnParams = handleWebParamsData("menuset/addChild", 2, 1);
    } else {
      returnParams = handleWebParamsData("menuset/one", 2, 1);
    }
  } else if (urlLink.indexOf("button/add") != -1) {
    //haha
    console.log("最后的商户号");
    console.log(postData);

    returnParams = handleWebParamsData("menuset/addChildButton", 2, 1);
  } else if (urlLink.indexOf("/menu/update") != -1) {
    //haha
    returnParams = handleWebParamsData("menuset/edit", 2, 2);
  } else if (urlLink.indexOf("/menu/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("menuset/del", 2, 3);
  } else if (urlLink.indexOf("/button/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("menuset/delChildButton", 2, 3);
  } else if (urlLink.indexOf("/device/model/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/model/add", 3, 1);
  } else if (urlLink.indexOf("/device/model/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/model/delete", 3, 3);
  } else if (urlLink.indexOf("device/model/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/model/update", 3, 2);
  } else if (urlLink.indexOf("/device/model/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/model/delete", 3, 3);
  } else if (urlLink.indexOf("/device/command/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/command/add", 3, 1);
  } else if (urlLink.indexOf("/device/command/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/command/update", 3, 2);
  } else if (urlLink.indexOf("/device/command/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/command/delete", 3, 3);
  } else if (urlLink.indexOf("/device/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/add", 3, 1);
  } else if (urlLink.indexOf("/device/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/update", 3, 2);
  } else if (urlLink.indexOf("/device/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/delete", 3, 3);
  } else if (urlLink.indexOf("device/execute") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/execute", 3, 1);
  } else if (urlLink.indexOf("/device/class/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/class/add", 3, 1);
  } else if (urlLink.indexOf("/device/class/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/class/update", 3, 2);
  } else if (urlLink.indexOf("/device/class/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/class/delete", 3, 3);
  } else if (urlLink.indexOf("/property/save") != -1) {
    //haha
    console.log("设备属性");
    console.log(postData);
    if (postData.id) {
      returnParams = handleWebParamsData("/device/check/update", 3, 2);
    } else {
      returnParams = handleWebParamsData("/device/check/add", 3, 1);
    }
  } else if (urlLink.indexOf("/property/del") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/check/delete", 3, 3);
  } else if (urlLink.indexOf("/device/upgrade/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/upgrade/add", 3, 1);
  } else if (urlLink.indexOf("/device/upgrade/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/upgrade/detail", 3, 2);
  } else if (urlLink.indexOf("/device/upgrade/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/upgrade/delete", 3, 3);
  } else if (urlLink.indexOf("/device/upgrade/publish") != -1) {
    //haha
    returnParams = handleWebParamsData("/device/upgrade/public", 3, 1);
  } else if (urlLink.indexOf("/category/add") != -1) {
    //haha
    if (postData.parentId) {
      returnParams = handleWebParamsData("/category/addChild", 4, 1);
    } else {
      returnParams = handleWebParamsData("/category/add", 4, 1);
    }
  } else if (urlLink.indexOf("/category/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/category/update", 4, 2);
  } else if (urlLink.indexOf("/category/del") != -1) {
    //haha
    returnParams = handleWebParamsData("/category/del", 4, 3);
  } else if (urlLink.indexOf("/employee/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/employee/add", 5, 1);
  } else if (urlLink.indexOf("/employee/update/status") != -1) {
    //haha
    returnParams = handleWebParamsData("/employee/update/status", 5, 2);
  } else if (urlLink.indexOf("/employee/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/employee/update", 5, 2);
  } else if (urlLink.indexOf("/employee/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/employee/delete", 5, 3);
  } else if (urlLink.indexOf("employee/user/init") != -1) {
    //haha
    returnParams = handleWebParamsData("/employee/user/init", 5, 2, "password");
  } else if (urlLink.indexOf("employee/bind/phone") != -1) {
    //haha
    returnParams = handleWebParamsData(
      "/employee/bind/phone",
      5,
      2,
      "updatePhone"
    );
  } else if (urlLink.indexOf("role/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/role/add", 5, 1);
  } else if (urlLink.indexOf("role/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/role/update", 5, 2);
  } else if (urlLink.indexOf("role/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/role/delete", 5, 3);
  } else if (urlLink.indexOf("department/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/department/add", 5, 1);
  } else if (urlLink.indexOf("department/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/department/update", 5, 2);
  } else if (urlLink.indexOf("department/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/department/delete", 5, 3);
  } else if (urlLink.indexOf("/wechat/config/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/wechat/config/add", 6, 1);
  } else if (urlLink.indexOf("/wechat/config/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/wechat/config/update", 6, 2);
  } else if (urlLink.indexOf("/wechat/config/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/wechat/config/delete", 6, 3);
  } else if (urlLink.split("com")[1] === "/manager//notify/model") {
    console.log("急急急急急急");
    console.log(postData);
    if (postData == undefined) {
      returnParams = handleWebParamsData("/notify/model/delete", 6, 3);
    } else if (postData.messageModelId) {
      returnParams = handleWebParamsData("/notify/model/update", 6, 2);
    } else {
      returnParams = handleWebParamsData("/notify/model/add", 6, 1);
    }

    //haha
  } else if (urlLink.indexOf("/process/save") != -1) {
    //haha
    if (postData.id) {
      returnParams = handleWebParamsData("/process/update", 6, 2);
    } else {
      returnParams = handleWebParamsData("/process/save", 6, 1);
    }
  } else if (urlLink.indexOf("/process/item/save") != -1) {
    //haha
    if (postData.isDevice) {
      returnParams = handleWebParamsData("/process/item/editDevice", 6, 2);
    } else {
      if (postData.id) {
        returnParams = handleWebParamsData("/process/item/update", 6, 2);
      } else {
        returnParams = handleWebParamsData("/process/item/save", 6, 1);
      }
    }
  } else if (urlLink.indexOf("/process/del") != -1) {
    //haha
    returnParams = handleWebParamsData("/process/delete", 6, 3);
  } else if (urlLink.indexOf("/process/item/del") != -1) {
    //haha
    returnParams = handleWebParamsData("/process/item/del", 6, 3);
  } else if (urlLink.indexOf("property/mapping/save") != -1) {
    //haha

    if (postData[0].editObj) {
      returnParams = handleWebParamsData("/property/mapping/update", 6, 2);
    } else {
      returnParams = handleWebParamsData("/property/mapping/save", 6, 1);
    }
  } else if (urlLink.indexOf("/model/advert/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/model/advert/add", 6, 1);
  } else if (urlLink.indexOf("/model/advert/update/status") != -1) {
    //haha
    returnParams = handleWebParamsData("/model/advert/update/status", 6, 2);
  } else if (urlLink.indexOf("/model/advert/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/model/advert/info", 6, 2);
  } else if (urlLink.indexOf("/model/advert/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/model/advert/delete", 6, 3);
  } else if (urlLink.indexOf("/role/model/addOrUpRoleModel") != -1) {
    //haha
    if (postData.roleModelId) {
      returnParams = handleWebParamsData("/role/model/updateRoleModel", 6, 2);
    } else {
      returnParams = handleWebParamsData("/role/model/addRoleModel", 6, 1);
    }
  } else if (urlLink.indexOf("role/model/deleteRoleModel") != -1) {
    //haha
    returnParams = handleWebParamsData("/role/model/deleteRoleModel", 6, 3);
  } else if (urlLink.indexOf("/role/model/addOrUpModelInfo") != -1) {
    //haha
    returnParams = handleWebParamsData(
      "/role/model/updateRoleModelPermisssion",
      6,
      2
    );
  } else if (urlLink.indexOf("/role/model/initModelHis") != -1) {
    //haha
    returnParams = handleWebParamsData("/role/model/initModelHis", 6, 1);
  } else if (urlLink.indexOf("dept/add") != -1) {
    //haha
    returnParams = handleWebParamsData("/dept/add", 6, 1);
  } else if (urlLink.indexOf("dept/update") != -1) {
    //haha
    returnParams = handleWebParamsData("/dept/update", 6, 2);
  } else if (urlLink.indexOf("dept/delete") != -1) {
    //haha
    returnParams = handleWebParamsData("/dept/delete", 6, 3);
  } else if (urlLink.indexOf("/dept/initDepModel") != -1) {
    //haha
    returnParams = handleWebParamsData("/dept/initDepModel", 6, 1);
  } else if (urlLink.indexOf("/wechat/config/status") != -1) {
    //haha
    returnParams = handleWebParamsData("/wechat/config/status", 6, 1);
  } else if (
    urlLink.indexOf("storage/outboundInbound/batchAddInboundNew") != -1
  ) {
    //maomao
    returnParams = handleWebParamsData(
      "/storage/outboundInbound/addOutbound",
      103,
      1
    );
  } else if (urlLink.indexOf("store/user/init") != -1) {
    //maomao
    returnParams = handleWebParamsData("/store/user/init", 101, 2, "password");
  } else if (urlLink.indexOf("/deposit/operate") != -1) {
    //maomao
    returnParams = handleWebParamsData("/deposit/operate", 101, 1);
  } else if (urlLink.indexOf("/store/bind/phone") != -1) {
    //maomao
    returnParams = handleWebParamsData(
      "/store/update/phone",
      101,
      2,
      "updatePhone"
    );
  } else if (urlLink.indexOf("regionagent/bind/phone") != -1) {
    returnParams = handleWebParamsData(
      "/regionagent/bind/phone",
      88,
      2,
      "updatePhone"
    );
  } else if (urlLink.indexOf("store/add") != -1) {
    //maomao
    returnParams = handleWebParamsData("/store/add", 101, 1);
  } else if (urlLink.indexOf("store/update") != -1) {
    //maomao
    returnParams = handleWebParamsData("/store/update", 101, 2);
  } else if (urlLink.indexOf("store/delete") != -1) {
    returnParams = handleWebParamsData("/store/delete", 101, 3);
  } else if (urlLink.indexOf("/agent/conf") != -1) {
    //maomao
    returnParams = handleWebParamsData("/store/set", 101, 1);
  } else if (urlLink.indexOf("device/update") != -1) {
    //maomao
    returnParams = handleWebParamsData("/device/update", 102, 2);
  } else if (urlLink.indexOf("/device/delete") != -1) {
    //maomao
    returnParams = handleWebParamsData("/device/delete", 102, 3);
  } else if (urlLink.indexOf("/device/execute") != -1) {
    //maomao
    returnParams = handleWebParamsData("equipmentList/command", 102, 1);
  } else if (urlLink.indexOf("storage/outboundInbound/addOutbound") != -1) {
    //maomao
    returnParams = handleWebParamsData(
      "/storage/outboundInbound/addOutbound",
      103,
      1
    );
  } else if (
    urlLink.indexOf("/rbac/user/password") != -1 ||
    urlLink.indexOf("/rbac/user/employee/info") != -1
  ) {
    //maomao
    returnParams = {
      logType: 1,
      appName: "代理商系统", //应用名称
      operType: 2, //操作类型
      type: 2,
      operTypeName: "编辑",
      orignalData: "", //
      currentData: "", //
      changeData: "", //
      api: "", //完整api地址
      apiParam: "", //参数
      apidata: "", //接口响应数据
      remark: "", //
      time: moment(new Date()).format("YYYY-MM-DD  HH:mm:ss"), //创建时间
      systemType: 6, //系统类型
      systemName: "代理商系统", //系统名称
      brandId: "", //
      brandName: "", //
      regionAgentId: "", //
      regionAgentName: "", //
      storeId: "", //
      storeName: "", //
      accountId: "", //登录用户ID
      accountName: "", //登录用户名
      createTime: moment(new Date()).format("YYYY-MM-DD  HH:mm:ss"), //创建时间
      modelId: "", //模块ID
      modelName: "代理商系统", //模块名称
      menuId: "",
      menuName: "代理商系统",
      operationId: "",
      operationName: "代理商系统",
      env: "", //dev:开发环境  pre:预发布环境  prd:生产环境
      deviceCode: "",
    };
    if (urlLink.indexOf("/rbac/user/password") != -1) {
      returnParams.password = "password";
    }
  }

  return returnParams;
}
